const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      document.body.dataset.onscroll = true;
    } else {
      document.body.removeAttribute('data-onscroll');
    }
  });
});

observer.observe(document.body);
